/**
 * @param {Record<string, unknown>|undefined} details - scoring_details from an eval result
 * @returns {boolean} whether this result was scored against an authored standard
 */
export function isGuidedResult(details: Record<string, unknown> | undefined): boolean {
  return details?.scoring_method === 'guided_grading_fidelity';
}
